import {
	Sidebar,
	SidebarContent,
	SidebarGroup,
	SidebarGroupContent,
	SidebarGroupLabel,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from './ui/sidebar';

import { SettingModules } from '@/configs/site-config';
import { Link } from 'react-router-dom';

const SettingSidebar = () => {
	return (
		<Sidebar variant="sidebar" className="top-16">
			<SidebarContent>
				<SidebarGroup>
					<SidebarGroupLabel>Setting</SidebarGroupLabel>
					<SidebarGroupContent>
						<SidebarMenu>
							{SettingModules.map(item => (
								<SidebarMenuItem key={item.title}>
									<SidebarMenuButton asChild>
										<Link to={`${item.href}`}>
											<item.icon />
											<span>{item.title}</span>
										</Link>
									</SidebarMenuButton>
								</SidebarMenuItem>
							))}
						</SidebarMenu>
					</SidebarGroupContent>
				</SidebarGroup>
			</SidebarContent>
		</Sidebar>
	);
};

export default SettingSidebar;
